const doc = [({"da":({"js":({"merfoto":({"layout":({"footer":({"index":({"pay_with":"Betal med"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;